import React from 'react';
import { strings } from '../../../../resources/strings';
import { Frame } from '../../../../models/Frame';
import { MultifocalInfo } from '../../../../models/MultifocalInfo';
import { Field, FieldType } from '../../../../common-components/Field/Field';
import { FormRecipeValues } from '../FormRecipeV2';
import { Container } from './styles';

interface ITabMultifocalProps {
  values?: FormRecipeValues;
  change: (values: FormRecipeValues) => void;
  frames?: Frame[];
}

const TabMultifocal: React.FC<ITabMultifocalProps> = ({
  values,
  change,
  frames
}) => {

  React.useEffect(() => {
    setTimeout(() => confirmMultifocalInfo(), 500);
  }, []);

  return (
    <Container>
      <Field
        type={FieldType.Text}
        label={strings.Bridge}
        value={values?.multifocalInfo?.actualBridge}
        change={(value) => changeMultifocalValue('actualBridge', value)}
        marginRight='10px'
        marginTop='0px'
        maxLength={2}
      />
      <Field
        type={FieldType.Text}
        label={strings.Rim}
        value={values?.multifocalInfo?.actualEyeWidth}
        change={(value) => changeMultifocalValue('actualEyeWidth', value)}
        marginRight='10px'
        marginTop='0px'
        maxLength={2}
      />
      <Field
        type={FieldType.Text}
        label={strings.Vertical}
        value={values?.multifocalInfo?.actualEyeHeight}
        change={(value) => changeMultifocalValue('actualEyeHeight', value)}
        marginRight='10px'
        marginTop='0px'
        maxLength={2}
      />
      <Field
        type={FieldType.Text}
        label={strings.LargestDiagonal}
        value={values?.multifocalInfo?.actualLargestDiagonal}
        change={(value) => changeMultifocalValue('actualLargestDiagonal', value)}
        marginTop='0px'
        maxLength={2}
      />
    </Container>
  );

  function changeMultifocalValue(field: string, value: any) {
    if (!values) values = new FormRecipeValues();
    if (!values.multifocalInfo) values.multifocalInfo = new MultifocalInfo();
    (values.multifocalInfo as any)[field] = value || undefined;
    change({ ...values });
  }

  function confirmMultifocalInfo() {
    if (!values) values = new FormRecipeValues();

    if (!values.multifocalInfo) values.multifocalInfo = new MultifocalInfo();

    values.multifocalInfoIsConfirmed = true;
    change({ ...values });
  }
}

export { TabMultifocal };